import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const vettingStageSelector = createSelector(stateSelector, (state) => state.stage);
const vettingFieldsSelector = createSelector(stateSelector, (state) => state.fields);
const vettingLoadingSelector = createSelector(stateSelector, (state) => state.isLoading);

export const VettingSelectors = {
  vettingStageSelector,
  vettingFieldsSelector,
  vettingLoadingSelector,
};
